const styles = {
  breadcrumb: {
    margin: "20px 0",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: "'MrEavesXLSanOT', sans-serif !important",
    "& a": {
      font: "normal normal 300 16px/19px MrEavesXLSanOT !important",
      cursor: "pointer",
      color: "#9DA3A4",
    },
    "& p": {
      font: "normal normal 300 16px/19px mreavesxlsanot-reg !important",
      color: "#272727",
    },
    "& button": {
      width: "auto",
    },
  },
};

export default styles;
